import type { ReactNode } from 'react';

interface ReportHeaderProps {
  systemName?:  string;
  reportTitle:  string;
  printedBy?:   string;
  printedAt?:   Date;
  /** Optional extra meta lines (e.g. "Company: ACME", "Period: Jan–Dec 2025") */
  meta?:        { label: string; value: string }[];
}

function fmtDateTime(d: Date): string {
  return d.toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
}

export const ReportHeader = ({
  systemName  = 'myLedger ONE',
  reportTitle,
  printedBy,
  printedAt,
  meta,
}: ReportHeaderProps): ReactNode => (
  <div style={{
    borderBottom: '2px solid #1e3a5f',
    paddingBottom: '12px',
    marginBottom: '16px',
  }}>
    {/* System name + report title */}
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <div>
        <div style={{ fontSize: '10px', color: '#6b7280', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '2px' }}>
          {systemName}
        </div>
        <div style={{ fontSize: '16px', fontWeight: 700, color: '#1e3a5f' }}>
          {reportTitle}
        </div>
      </div>
      {/* Print metadata */}
      <div style={{ textAlign: 'right', fontSize: '10px', color: '#6b7280' }}>
        {printedAt && (
          <div>Printed: {fmtDateTime(printedAt)}</div>
        )}
        {printedBy && (
          <div>Printed by: {printedBy}</div>
        )}
      </div>
    </div>

    {/* Extra meta */}
    {meta && meta.length > 0 && (
      <div style={{ display: 'flex', gap: '24px', marginTop: '6px', fontSize: '10px', color: '#374151' }}>
        {meta.map(m => (
          <span key={m.label}>
            <span style={{ color: '#6b7280' }}>{m.label}:</span>{' '}
            <strong>{m.value}</strong>
          </span>
        ))}
      </div>
    )}
  </div>
);
